module.exports = __webpack_public_path__ + "static/media/studiobrahma.fc754a47.png";